module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.to) ? _c('p', {
    staticClass: "expired"
  }, [_vm._v("Сертификат "), _c('span', {
    staticClass: "expired_accent"
  }, [_vm._v("активирован")]), _vm._v(", но финансирование сертификата не осуществляется. Для зачисления номинала на счет сертификата обратитесь, пожалуйста, в любое учреждение доп. образования из "), _c('router-link', {
    staticClass: "expired_accent",
    attrs: {
      "target": "_blank",
      "to": _vm.to
    }
  }, [_vm._v("перечня")]), _vm._v(" или оставьте заявку онлайн.")], 1) : _c('p', {
    staticClass: "expired"
  }, [_vm._v("Ваше заявление принято. Регламентный срок обработки — 10 рабочих дней.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d6061b","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/expiredcert/ExpiredCert.vue
// module id = 7a871c1c00d45b53e25b
// module chunks = 9